__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "service-awards-webapp";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@nackle/biw-web-router", "2.0.12", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(558)]).then(() => (() => (__webpack_require__(61670))))));
			register("@nackle/bridge", "3.0.54", () => (Promise.all([__webpack_require__.e(698), __webpack_require__.e(823)]).then(() => (() => (__webpack_require__(2698))))));
			register("@nackle/intl-tools", "1.4.85", () => (Promise.all([__webpack_require__.e(585), __webpack_require__.e(930), __webpack_require__.e(701)]).then(() => (() => (__webpack_require__(62930))))));
			register("@nackle/origami", "1.2.13", () => (Promise.all([__webpack_require__.e(585), __webpack_require__.e(463), __webpack_require__.e(559), __webpack_require__.e(100), __webpack_require__.e(980), __webpack_require__.e(498)]).then(() => (() => (__webpack_require__(8559))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(8143))), 1);
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(824), __webpack_require__.e(980), __webpack_require__.e(415)]).then(() => (() => (__webpack_require__(74824))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(30758))), 1);
			register("redux", "4.2.1", () => (__webpack_require__.e(714).then(() => (() => (__webpack_require__(333))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};